import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Confirm from '../../../../base/Confirm';
import ListView from '../../../../base/ListView';
import { dateRender } from '../../../../libs/utils';
import { selectUser } from '../../../../redux/auth/selectors';
import { selectEvent } from '../../../../redux/preferences/selectors';
import { selectVenues } from '../../../../redux/venues/selectors';
import { WRISTBANDS_ACTIONS } from '../../../../redux/wristbands/actions';
import {
  selectWristbands,
  wristbandsFilters,
  wristbandsLoaded,
  wristbandsMeta,
} from '../../../../redux/wristbands/selectors';
import { getCompanies } from '../../../../services/api/companies';
import { getCrewMembers } from '../../../../services/api/crewMembers';
import { getPeriods } from '../../../../services/api/periods';
import AdminSubHeader from '../../../layouts/partials/AdminSubheader';
import BarcodeButton from './BarcodeButton';
import PreviewButton from './PreviewButton';

class _Wristbands extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      wristbands: this.props.wristbands,
      wristbandsLoaded: this.props.wristbandsLoaded,
      filters: this.props.filters,
      baseFilters: {
        'page[number]': 1,
        'page[size]': 10,
        'filter[event_id]': this.props.event.id,
        'sort': '-updated_at',
        'include':
          'crewMember.user,crewMember.registration.company,createdByUser,printedByUser,accessVoucher,accessVoucher.accessVoucherTemplate,accessVoucher.accessVoucherTemplate.period',
      },
      periods: [],
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleUpdate = this._handleUpdate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    wristbands: PropTypes.array,
    wristbandsLoaded: PropTypes.bool,
    loadWristbands: PropTypes.func,
    createWristband: PropTypes.func,
    updateWristband: PropTypes.func,
    deleteWristband: PropTypes.func,
    venues: PropTypes.array,
    match: PropTypes.object,
    wristbandMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func,
    event: PropTypes.object,
    user: PropTypes.object,
  };

  UNSAFE_componentWillMount() {
    this.props.updateFilters(this.state.baseFilters);

    getPeriods(this.props.event.id).then((response) => {
      this.setState({
        periods: response.data,
      });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {
      wristbands: nextProps.wristbands,
      wristbandsLoaded: nextProps.wristbandsLoaded,
    };

    this.setState(newState);
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleCreate(values) {
    const data = {
      name: values.name,
    };
    this.props.createWristband(data);
  }

  _handleUpdate(values) {
    const data = {
      name: values.name,
    };

    this.props.updateWristband(values.id, data);
  }

  _handleDelete(id) {
    Confirm(
      'Are you sure you want to delete this wristband? This action can not be undone, please make sure no festival is using this wristband.',
      {
        title: 'Delete Wristband',
        confirmStyle: 'btn-danger',
        confirmText: 'Delete',
      }
    ).then(
      (result) => {
        this.props.deleteWristband(id);
      },
      (result) => {}
    );
  }

  render() {
    const { wristbandMeta, filters } = this.props;
    const { wristbands, wristbandsLoaded, periods } = this.state;

    const listViewConf = {
      dataSet: wristbands,
      dataMeta: wristbandMeta,
      columns: [
        {
          key: 'crewMember.registration.company.name',
          value: 'Company',
        },
        {
          key: 'name',
          value: 'Crewmember',
          render: (item) => `${item.crewMember.user.firstName} ${item.crewMember.user.lastName}`,
        },
        {
          key: 'accessVoucher.accessVoucherTemplate.period.name',
          value: 'Period',
        },
        {
          key: 'city',
          value: 'Day',
          render: (item) =>
            item.accessVoucher.accessVoucherTemplate.day ? item.accessVoucher.accessVoucherTemplate.day : 'Combi',
        },
        {
          key: 'code',
          value: 'Barcode',
        },
        {
          key: 'createdAt',
          value: 'Printed At',
          render: (wristband) => dateRender(wristband.createdAt),
        },
        {
          key: 'printedBy',
          value: 'Printed By',
          render: (item) => item.createdByUser?.fullName ?? '',
        },
        {
          key: 'status',
          value: 'Status',
          render: (wristband) => (
            <span className={'m-badge m-badge--' + (wristband.invalidatedAt ? 'danger' : 'success') + ' m-badge--wide'}>
              {wristband.invalidatedAt ? 'Invalidated' : 'Active'}
            </span>
          ),
        },
      ],
      baseFilters: filters,
      filters: [
        {
          label: 'Barcode',
          icon: 'la-barcode',
          type: 'text',
          key: 'code',
        },
        {
          label: 'Company',
          icon: 'la-map-marker',
          type: 'typeahead',
          options: (value) =>
            getCompanies({
              'filter[name]': value,
            }),
          key: 'company_id',
          labelKey: 'name',
        },
        {
          label: 'Crewmember',
          icon: 'la-user',
          type: 'typeahead',
          options: (value) =>
            getCrewMembers({
              'filter[name_like]': value,
              'filter[event_id]': this.props.event.id,
              'include': 'user',
            }),
          key: 'crew_member_id',
          labelKey: (item) => item.user.firstName + ' ' + item.user.lastName,
        },
        {
          label: 'Period',
          icon: 'la-calendar',
          key: 'period_id',
          type: 'select',
          dataset: periods.map((period) => {
            return {
              key: period.id,
              value: period.name,
            };
          }),
        },
      ],
      actions: {
        deleteLink: false,
        editLink: false,
        detailsLink: false,

        // deleteFunction: this._handleDelete,

        customLink: (wristband) => {
          return (
            <span>
              <Link
                to={'tracker/' + wristband.crewMemberId}
                className="btn btn-outline-warning m-btn btn-sm  m-btn--icon m--margin-left-5"
              >
                Tracker
              </Link>
              <PreviewButton wristband={wristband} />
              <BarcodeButton barcode={wristband.code} />
            </span>
          );
        },
      },
      url: 'wristbands',
    };

    return [
      <AdminSubHeader title="Wristbands" key="subheader" breadcrumbs={[]}>
        <Link
          to="/admin/wristbands/create"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-plus" />
        </Link>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        {wristbandsLoaded && (
          <div className="row">
            <div className="col-xl-12">
              <ListView config={listViewConf} handleFilterUpdate={this._handleFilterUpdate} />
            </div>
          </div>
        )}
      </div>,
    ];
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadWristbands: () => dispatch(WRISTBANDS_ACTIONS.loadAllRequest()),
  createWristband: (values) => dispatch(WRISTBANDS_ACTIONS.createRequest(values)),
  updateWristband: (id, values) => dispatch(WRISTBANDS_ACTIONS.updateRequest(id, values)),
  deleteWristband: (id) => dispatch(WRISTBANDS_ACTIONS.deleteRequest(id)),
  updateFilters: (filters) => dispatch(WRISTBANDS_ACTIONS.updateFilters(filters)),
});

const mapStateToProps = function (state) {
  return {
    venues: selectVenues(state),
    wristbands: selectWristbands(state),
    wristbandMeta: wristbandsMeta(state),
    wristbandsLoaded: wristbandsLoaded(state),
    filters: wristbandsFilters(state),
    event: selectEvent(state),
    user: selectUser(state),
  };
};

const Wristbands = connect(mapStateToProps, mapDispatchToProps)(_Wristbands);

export default Wristbands;
